var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCameraDisabled = function SvgCameraDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 164"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1 80.4c-42.7 42.8-49.3 49.7-48.1 51 .7.9 1.8 1.6 2.4 1.6.6 0 23.3-22.2 50.4-49.3C125.9 34.6 129 31 123.1 31c-.9 0-23.9 22.2-51 49.4zM35.4 46.4c-1.7.8-3.4 2.1-3.8 3.1-.8 2.3-.8 64 .1 64.9.7.7 69.3-67.2 69.3-68.6 0-.5-14.1-.8-31.2-.8-24 .1-32 .4-34.4 1.4zM128.3 60.9 116 72.1v-9.5c0-5.2-.4-9.7-.8-10-.5-.3-15.9 14.6-34.3 33l-33.4 33.5 31.7-.3c38.9-.4 36.1.8 36.6-15.8l.4-10.9 12.2 11.1 12.1 11.2.3-16.2c.1-8.9.1-23.5 0-32.4l-.3-16.2-12.2 11.3z"
  }))));
};

export default SvgCameraDisabled;